    export class Journal{

    keyword:String
    journalName:string
    uniqueId:string
}